import { render, staticRenderFns } from "./PurchaseRequestNavsTabs.vue?vue&type=template&id=b12ef270&"
import script from "./PurchaseRequestNavsTabs.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestNavsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports